import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    OnDestroy,
} from '@angular/core';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { SubSink } from 'subsink';
import { ActivatedRoute, Router } from '@angular/router';
import { map, withLatestFrom, switchMap, tap, take } from 'rxjs/operators';
import { IAclID } from 'src/app/acl-data/aclID.interface';
import { combineLatest, BehaviorSubject } from 'rxjs';
import { TopnavInfoService } from 'src/app/navigation/menuInterfaces/topnav-info.service';
import { IBookmarkEntry } from 'src/app/navigation/menuInterfaces/bookmark-entry.interface';
import { Folder } from 'src/app/acl-data/folder/folder.dto';
import { NgForm } from '@angular/forms';
import { deepCopy } from 'src/app/acl-data/general/generic.function';

@Component({
    templateUrl: './folder-settings.component.html',
    styleUrls: ['./folder-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FolderSettingsComponent implements OnInit, OnDestroy {
    subSink = new SubSink();

    folderID$ = this.route.paramMap.pipe(
        map(v => v.get('folderID')),
        withLatestFrom(this.route.data),
        map(([idValue, routeValue]) => {
            return {
                id: idValue,
                objectStore: routeValue.parentMenu.data.id,
            } as IAclID;
        })
    );

    folderCopy$ = new BehaviorSubject<Folder>(null);
    folder$ = this.folderID$.pipe(
        switchMap(v =>
            this.folderService.getByID(v.objectStore, v.id, false, true)
            
        )
    );

    ngOnInit(): void {
        this.subSink.add(
            this.folder$.subscribe(v => {
                this.folderCopy$.next(deepCopy(v))
            })
        );

        this.subSink.add(
            combineLatest([
                this.route.paramMap,
                this.route.data,
                this.folderID$,
            ])
                .pipe(
                    switchMap(([parmMap, routeValue, ID]) =>
                        this.folderService
                            .getByID(
                                // Category For breadcrumb
                                routeValue.parentMenu.data.id,
                                ID.id,
                                false,
                                true
                            )
                            .pipe(
                                tap(folderLibrary => {
                                    if (!!folderLibrary) {
                                        if (
                                            folderLibrary.propertiesObj
                                                .ClassDescription ===
                                            'CategoryFolder'
                                        ) {
                                            this.folderService
                                                .getByID(
                                                    ID.objectStore,
                                                    folderLibrary.parentID
                                                )
                                                .subscribe(categoryFolder => {
                                                    const result: IBookmarkEntry[] = [];
                                                    result.push({
                                                        path: `/${ID.objectStore}/browse/${categoryFolder.id}`,
                                                        description:
                                                            categoryFolder
                                                                .propertiesObj
                                                                .FolderName,
                                                    });
                                                    this.topNavInfoService.addExtraBreadCrumbData(
                                                        result
                                                    );
                                                    result.push({
                                                        path: `/${ID.objectStore}/browse/${folderLibrary.id}`,
                                                        description:
                                                            folderLibrary
                                                                .propertiesObj
                                                                .FolderName,
                                                    });
                                                    this.topNavInfoService.addExtraBreadCrumbData(
                                                        result
                                                    );

                                                    result.push({
                                                        path: `/${ID.objectStore}/browse/${ID.id}`,
                                                        description: 'Settings',
                                                    });
                                                    this.topNavInfoService.addExtraBreadCrumbData(
                                                        result
                                                    );
                                                });
                                        } else {
                                            const result: IBookmarkEntry[] = [];
                                            result.push({
                                                path: `/${ID.objectStore}/browse/${folderLibrary.id}`,
                                                description:
                                                    folderLibrary.propertiesObj
                                                        .FolderName,
                                            });
                                            this.topNavInfoService.addExtraBreadCrumbData(
                                                result
                                            );

                                            result.push({
                                                path: `/${ID.objectStore}/browse/${ID.id}`,
                                                description: 'Settings',
                                            });
                                            this.topNavInfoService.addExtraBreadCrumbData(
                                                result
                                            );
                                        }
                                    }
                                })
                            )
                    )
                )
                .subscribe(v => {
                    return;
                })
        );
    }
    ngOnDestroy(): void {
        this.subSink.unsubscribe();
    }

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private folderService: FolderService,
        private topNavInfoService: TopnavInfoService
    ) {}

    save = (folder: Folder) => {
        console.log('Saving', folder);
        this.folderID$.pipe(take(1)).subscribe(ID => {
            const toUpdate = { ...folder };
            toUpdate.objectStore = ID.objectStore;

            //Backend does not accept true or false only 1 or 0
            console.log('Checked: ' +toUpdate.propertiesObj.Folder60DayAlert +' ' +toUpdate.propertiesObj.Folder180DayAlert )
            toUpdate.propertiesObj.Folder60DayAlert = toUpdate.propertiesObj.Folder60DayAlert ? 1 : 0
            toUpdate.propertiesObj.Folder180DayAlert = toUpdate.propertiesObj.Folder180DayAlert ? 1 : 0

            this.folderService.update(toUpdate).subscribe(v => {
                this.router.navigate([
                    '/',
                    ID.objectStore,
                    'browse',
                    folder.parentID,
                ]);
            });
        });
    };

    check(input: NgForm) {
        console.log('Check', input);
    }
}
